const ShareUrl = {
  Facebook: 'https://www.facebook.com/sharer/sharer.php',
  LinkedIn: 'https://www.linkedin.com/sharing/share-offsite/',
  Twitter: 'https://twitter.com/intent/tweet/'
};

export default ShareUrl;
